import dayjs from 'dayjs'
/**
 * 时间格式转换
 * @param {*} date
 */
export const timeFormat = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  return dayjs(date).format(format)
}
export const timeFormatDate = (date, format = 'YYYY-MM-DD') => {
  return dayjs(date).format(format)
}
// 计算附件大小
export function formatSize(size, pointLength, units) {
  let unit;
  units = units || ['B', 'KB', 'MB', 'GB', 'TB'];
  while ((unit = units.shift()) && size > 1024) {
    size = size / 1024;
  }
  return (unit === 'B' ? size : size.toFixed(pointLength === undefined ? 2 : pointLength)) + unit;
}


/**
 * 将数字转换为金额大写
 * @param {number|string} num - 要转换的数字或数字字符串
 * @returns {string} 转换后的金额大写
 */
export const numberToAmountUppercase = (num) => {
  // 处理空值或非数字情况
  if (!num && num !== 0) return '零元零角零分';

  // 转换为数字并处理
  let number = parseFloat(num);
  if (isNaN(number)) return '无效数字';

  // 处理超出范围的数字
  if (number > 999999999999.99 || number < -999999999999.99) {
    return '数字超出范围';
  }

  // 定义基本字符
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const unit = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟'];
  const decimalUnit = ['角', '分'];

  // 处理负数
  let sign = '';
  if (number < 0) {
    sign = '负';
    number = -number;
  }

  // 分离整数和小数部分
  let integerPart = Math.floor(number).toString();
  let decimalPart = Math.round((number - Math.floor(number)) * 100).toString();
  decimalPart = decimalPart.padStart(2, '0'); // 确保两位小数

  let result = '';

  // 处理整数部分 - 完整显示所有位，包括零
  if (integerPart === '0') {
    result += digit[0];
  } else {
    for (let i = 0; i < integerPart.length; i++) {
      const digitIndex = parseInt(integerPart[i]);
      const unitIndex = integerPart.length - 1 - i;

      // 无论是否为零，都显示数字和对应的单位
      result += digit[digitIndex] + unit[unitIndex];
    }
  }

  // 添加"元"
  result += '元';

  // 处理小数部分
  // 处理角
  result += digit[parseInt(decimalPart[0])] + decimalUnit[0];

  // 处理分
  result += digit[parseInt(decimalPart[1])] + decimalUnit[1];

  // 添加符号并返回
  return `(金额大写: ${sign + result})`;
}